// api 统一配置 两端共用
export const CROSS_API = {
  wallet: {
    submitFiatWithdraw: "/v3/wallet/fiat/withdrawal", // 申请法币出金
    fiatWithdrawList: "/v3/wallet/fiat/orders", // 法币出金列表
    fiatWithdrawDetail: "/v3/wallet/fiat/order/{id}", // 法币出金详情
    applyWithdraw: "v3/wallet/withdrawal-apply", // 电子货币提币
  },
  ai: {
    loginEdgen: "/v3/auth/customer/login-edgen",
  },
  docs: {
    exportHistorySignUrl: "/v3/docs/sign-url/{id}", // 生成文件下载签名
    getExportHistoryList: "/v3/docs/history", // 分页查询文件记录历史
    exportHistory: "/v3/docs/history", // 异步导出数据
    exportHistoryPreview: "/v3/docs/preview", // 导出前校验
    downloadHistory: "/v3/docs/history/{id}", // 下载历史文件
  },
  customers: {
    getAttachmentList: "/v3/customers/attachments", // 查询用户附件列表
    downloadAttachmentFile: "/v3/customers/attachment-file", // 下载用户附件
    acceptAgreement: "/v3/auth/customer/agreement", // 接受最新服务协议
  },
};
